import classNames from 'classnames/bind'
import { useCallback, useMemo, VFC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setPageBanner } from '../../../redux/slices/dashboard'
import { Store } from '../../../redux/store'
import AccountTypeBanner from '../AccountTypeBanner'
import cross from './cross.svg'
import styles from './global-banner.module.scss'



const cx = classNames.bind(styles)

interface GlobalBannerProps {
    onClose?(): void
    hasCrossIcon?: boolean
}

const GlobalBanner: VFC<GlobalBannerProps> = ({ hasCrossIcon, onClose }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { pageBanner } = useSelector((state: Store) => state.UI.Dashboard)

    const handleCloseClick = useCallback(() => {
        dispatch(setPageBanner(null))
        onClose && onClose()
    }, [dispatch, onClose])

    const content = useMemo(() => {
        switch (pageBanner) {
            case 'creditCardBanner':
                return t('dashboard.withdraw.creditCardBanner')
            case 'uaeDepositBanner':
                return t('dashboard.deposit.uaeDepositBanner')
            case 'saDepositBanner':
                return t('dashboard.deposit.saDepositBanner')
            case 'ukDepositBanner':
                return t('dashboard.deposit.ukDepositBanner')
            default:
                return null
        }
    }, [pageBanner, t])

    if (pageBanner === 'accountTypeBanner') return <AccountTypeBanner />
    return !pageBanner
        ? null
        : (
            <div className={cx('content')}>
                {content}
                {hasCrossIcon && <img src={cross} alt="banner-cross" onClick={handleCloseClick} />}
            </div>
        )
}

export default GlobalBanner
